import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      overflow: 'hidden',
      display: 'flex',
      height: '100%',
      flexDirection: 'column',
    },
    list: {
      overflowX: 'auto',
      marginTop: theme.spacing(2),
    },
  })
);
